import { Toolbar } from "@mui/material";
import Logo from "../../assets/logo.png";
import "./Header.css";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import BellIcon from "../common/BellIcon";
import MessageIcon from "../common/MessageIcon";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileDropdown from "../TopSection/ProfileDropdown";
import MessageDrawer from "../TopSection/MessageDrawer";
import NotificationDropdown from "../TopSection/NotificationDropdown";
import NotificationComponent from "../TopSection/NotificationComponent";
import Alerts from "../TopSection/Alerts";
import { useState, useRef, useEffect } from "react";
import { fetchUserInfo } from "../../api/fetchUserInfo";
import { useSelector, useDispatch } from "react-redux";
import {
  setCurrentRole,
  setLocationDetails,
  setSelectedPlant,
} from "../../redux/actions/userSlice";
import type { RootState } from "../../redux/store";
import { useMsal } from "@azure/msal-react";
import { triggerToast } from "../common/GlobalToast";
import { useSnackbar } from "../SnakBar/AppSnackbarProvider";
import {
  getDefaultPathForRole,
  getRoleDisplayName,
  resolveHighestPriorityRole,
  resolveRoleId,
} from "../../constants/roleAccess";

const roles = ["Planner", "Admin", "Approver"];
const regions = ["North", "South", "East", "West"];
const locations = ["Ballina"];
const controllers = ["MRP Controller"];

const Header = (props) => {
  // User info state
  const { accounts } = useMsal();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const azureUser = accounts && accounts.length > 0 ? accounts[0] : null;
  const azureName = azureUser?.name || azureUser?.idTokenClaims?.name || "";
  const azureEmail =
    azureUser?.username || azureUser?.idTokenClaims?.email || "";
  const apiCall = useSelector((state: RootState) => state.userRoles?.apiCall);
  const [userInfo, setUserInfo] = useState(null);
  const [userEmail, setUserEmail] = useState(azureEmail || "");
  const [userName, setUserName] = useState(azureName || "");
  // Dropdown data
  const [roleOptions, setRoleOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [plantOptions, setPlantOptions] = useState([]);
  // Selected values
  const [selectedRoleDropdown, setSelectedRoleDropdown] = useState("");
  const [selectedRegionDropdown, setSelectedRegionDropdown] = useState<
    string[]
  >([]);
  const [selectedPlantDropdown, setSelectedPlantDropdown] = useState<string[]>(
    [],
  );

  let toastShown = false;
  let filteredRoles: string[] = [];
  const locationData = [
    "/admin/adminView",
    "/admin/data-error",
    "/admin/support-ticket-summary",
  ];
  const fetchUserInfoDetails = async () => {
    try {
      setLoading(true);
      dispatch(setCurrentRole(null));

      const data = await fetchUserInfo(userEmail);
      if (!data) {
        sessionStorage.removeItem("selectedRole");
        sessionStorage.removeItem("selectedRoleId");
        sessionStorage.removeItem("selectedRegion");
        sessionStorage.removeItem("selectedPlant");
        const azureRoleRaw = sessionStorage.getItem("userRoles");
        const azureRoles: string[] = azureRoleRaw ? JSON.parse(azureRoleRaw) : [];

        if (azureRoles.length === 0) {
          enqueueSnackbar({
            message: "You do not have access to any roles. You will be redirected to request access.",
            severity: "warning",
            autoHideDuration: 2000,
          });
          setTimeout(() => {
            window.location.href = process.env.REACT_APP_USER_ACCESS_MANAGEMENT_URL || "/";
          }, 2000);
          return;

        } else {
          enqueueSnackbar({
            message: "You do not have access. Redirecting to home page...",
            severity: "warning",
            autoHideDuration: 2000,
          });
          setTimeout(() => {
            window.location.href = process.env.REACT_APP_CATALOGUE_URL || "/";
          }, 2000);
          return;
        }

        // Show toast and redirect to base URL

      }

      setUserInfo(data);

      //  Prefer Azure AD values
      setUserName(azureName || data.userName);
      setUserEmail(azureEmail || data.userEmail);

      /* ---------------- ROLE RECONCILIATION (AZURE vs API) ---------------- */

      //  Get Azure roles from session (safe parse)
      const azureRoleRaw = sessionStorage.getItem("userRoles");
      const azureRoles: string[] = azureRoleRaw ? JSON.parse(azureRoleRaw) : [];

      //  Normalize Azure roles for comparison
      const normalizedAzureRoles = azureRoles.map((r) => r.toLowerCase());
      const normalizedAzureRoleIds = new Set<string>();
      azureRoles.forEach((role) => {
        const roleId = resolveRoleId(role);
        if (roleId) {
          normalizedAzureRoleIds.add(roleId);
        }
      });

      //  Roles from API
      const apiRoles = data.combinationDetails.map((c) => c.role);
      //  Filter API roles based on Azure roles (case‑insensitive)
      // if (apiRoles?.length === 0) {
      //   filteredRoles = azureRoles || [];
      // } else {
      //   filteredRoles = apiRoles?.filter((role) =>
      //     normalizedAzureRoles.includes(role.toLowerCase()),
      //   );
      // }
      filteredRoles = apiRoles?.filter((role) => {
        const apiRoleId = resolveRoleId(role);
        if (apiRoleId) {
          return normalizedAzureRoleIds.has(apiRoleId);
        }

        return normalizedAzureRoles.includes(role.toLowerCase());
      });
      //  Safety fallback
      if (filteredRoles.length === 0) {
        // Show info message and then redirect
        console.log("URL", process.env.REACT_APP_USER_ACCESS_MANAGEMENT_URL)
        const accessMgmtUrl = process.env.REACT_APP_USER_ACCESS_MANAGEMENT_URL;
        if (accessMgmtUrl) {
          if (!toastShown) {
            triggerToast(
              "You do not have access to any roles. You will be redirected to request access.",
              "warning",
            );
            toastShown = true;
          }

          setTimeout(() => {
            const accessMgmtUrl =
              process.env.REACT_APP_USER_ACCESS_MANAGEMENT_URL;
            if (accessMgmtUrl) {
              window.location.href = accessMgmtUrl;
            }
          }, 2000);
        }
        return;
      }

      // // If 'Admin' is present, keep only 'Admin' in the roles
      // if (filteredRoles.some(r => r.toLowerCase() === 'admin')) {
      //   filteredRoles = filteredRoles.filter(r => r.toLowerCase() === 'admin');
      // }
      setRoleOptions(filteredRoles);

      /* ---------------- SELECTED ROLE SETUP ---------------- */

      const storedRole = sessionStorage.getItem("selectedRole");

      // When no stored role, pick by priority rather than API array order
      const highestPriorityRole = resolveHighestPriorityRole(filteredRoles);
      let initialRole = highestPriorityRole
        ? (filteredRoles.find((r) => resolveRoleId(r) === highestPriorityRole) ?? filteredRoles[0])
        : filteredRoles[0];

      if (
        storedRole &&
        filteredRoles.some(
          (r) => r.toLowerCase() === storedRole.toLowerCase(),
        )
      ) {
        initialRole =
          filteredRoles.find(
            (r) => r.toLowerCase() === storedRole.toLowerCase(),
          ) ?? initialRole;
      }
      sessionStorage.setItem("selectedRole", initialRole);
      const resolvedInitialRoleId = resolveRoleId(initialRole) ?? initialRole;
      sessionStorage.setItem("selectedRoleId", resolvedInitialRoleId);

      setSelectedRoleDropdown(initialRole);
      dispatch(setCurrentRole(resolvedInitialRoleId));

      // Preserve deep-link route (e.g., email links) and only route by role on root.
      const hasExplicitRoute = location.pathname && location.pathname !== "/";
      if (!hasExplicitRoute) {
        navigate(getDefaultPathForRole(initialRole));
      }

      /* ---------------- REGION & PLANT SETUP ---------------- */

      const combo = data.combinationDetails.find(
        (c) => c.role.toLowerCase() === initialRole.toLowerCase(),
      );

      const availableRegions =
        combo?.regionDetails?.map((r) => r.regionName) ?? [];

      //  Auto‑select all regions
      setRegionOptions(availableRegions);
      setSelectedRegionDropdown(availableRegions);
      sessionStorage.setItem(
        "selectedRegion",
        JSON.stringify(availableRegions),
      );

      //  Auto‑select all plants
      const allPlants =
        combo?.regionDetails?.flatMap((r) => r.plantDetails ?? []) ?? [];

      const uniquePlants: string[] = Array.from(new Set(allPlants));

      setPlantOptions(uniquePlants);
      setSelectedPlantDropdown(uniquePlants);
      sessionStorage.setItem("selectedPlant", JSON.stringify(uniquePlants));
      dispatch(setSelectedPlant(uniquePlants));
      setLoading(false)

    } catch (error) {
      console.error("Error fetching user info:", error);
      enqueueSnackbar({
        message: `Something went wrong while fetching user info.Please logout and login again!`,
        severity: "error",
        autoHideDuration: 2000,
      });
      sessionStorage.removeItem("selectedRole");
      sessionStorage.removeItem("selectedRoleId");
      sessionStorage.removeItem("selectedRegion");
      sessionStorage.removeItem("selectedPlant");
      setLoading(false)

    }
  };
  // Fetch user info on mount
  useEffect(() => {
    fetchUserInfoDetails();
  }, []);

  // Handle role dropdown change
  const handleRoleDropdownChange = (role: string) => {
    setSelectedRoleDropdown(role);
    sessionStorage.setItem("selectedRole", role);
    const resolvedRoleId = resolveRoleId(role) ?? role;
    sessionStorage.setItem("selectedRoleId", resolvedRoleId);

    const combo = userInfo?.combinationDetails.find(
      (c) => c.role.toLowerCase() === role.toLowerCase(),
    );

    const regions = combo?.regionDetails ?? [];
    const regionNames = regions.map((r) => r.regionName);

    //  AUTO‑SELECT ALL REGIONS
    setRegionOptions(regionNames);
    setSelectedRegionDropdown(regionNames);
    sessionStorage.setItem("selectedRegion", JSON.stringify(regionNames));

    //  AUTO‑SELECT ALL PLANTS
    const allPlants = regions.flatMap((r) => r.plantDetails ?? []);
    const uniquePlants: string[] = Array.from(new Set(allPlants));
    setPlantOptions(uniquePlants);
    setSelectedPlantDropdown(uniquePlants);
    sessionStorage.setItem("selectedPlant", JSON.stringify(uniquePlants));

    dispatch(setCurrentRole(resolvedRoleId));
    dispatch(setSelectedPlant(uniquePlants));
    navigate(getDefaultPathForRole(role), { replace: true });
  };

  // Handle region dropdown change
const handleRegionDropdownChange = (event) => {
  const value = event.target.value as string[];
  if (!userInfo || !userInfo.combinationDetails) {
    setSelectedRegionDropdown([]);
    setPlantOptions([]);
    setSelectedPlantDropdown([]);
    return;
  }
  const combo = userInfo.combinationDetails.find(
    (c) => c.role.toLowerCase() === selectedRoleDropdown.toLowerCase(),
  );
  if (!combo || !combo.regionDetails) {
    setSelectedRegionDropdown([]);
    setPlantOptions([]);
    setSelectedPlantDropdown([]);
    return;
  }

  // Handle Select/Deselect All
  if (value.includes(SELECT_ALL)) {
    const isAllSelected = selectedRegionDropdown.length === regionOptions.length && regionOptions.length > 0;
    const newRegions = isAllSelected ? [] : regionOptions;
    setSelectedRegionDropdown(newRegions);
    sessionStorage.setItem("selectedRegion", JSON.stringify(newRegions));
    // Update plants accordingly
    const newPlants = isAllSelected
      ? []
      : Array.from(
          new Set(
            regionOptions.flatMap(
              (r) =>
                combo?.regionDetails.find((x) => x.regionName === r)?.plantDetails ?? []
            )
          )
        );
    setPlantOptions(newPlants);
    setSelectedPlantDropdown(newPlants);
    sessionStorage.setItem("selectedPlant", JSON.stringify(newPlants));
    return;
  }

  // If no regions selected, clear plants
  if (value.length === 0) {
    setSelectedRegionDropdown([]);
    setPlantOptions([]);
    setSelectedPlantDropdown([]);
    sessionStorage.setItem("selectedRegion", JSON.stringify([]));
    sessionStorage.setItem("selectedPlant", JSON.stringify([]));
    return;
  }

  // Preserve only plants that are still valid for selected regions
  const validPlants = Array.from(
    new Set(
      value.flatMap(
        (r) =>
          combo?.regionDetails.find((x) => x.regionName === r)?.plantDetails ?? []
      )
    )
  );
  const newSelectedPlants = selectedPlantDropdown.filter((p) => validPlants.includes(p));
  setSelectedRegionDropdown(value);
  setPlantOptions(validPlants);
  setSelectedPlantDropdown(newSelectedPlants);
  sessionStorage.setItem("selectedRegion", JSON.stringify(value));
  sessionStorage.setItem("selectedPlant", JSON.stringify(newSelectedPlants));
};



  // Handle plant dropdown change
 const handlePlantDropdownChange = (event) => {
  const value = event.target.value as string[];

  // ✅ STEP 5.1: Handle ALL option
  if (value.includes(SELECT_ALL)) {

    // ✅ STEP 5.2: Check if all plants are selected
    const isAllSelected =
      selectedPlantDropdown.length === plantOptions.length;

    // ✅ STEP 5.3: Toggle
    const newPlants = isAllSelected ? [] : plantOptions;

    setSelectedPlantDropdown(newPlants);
    sessionStorage.setItem("selectedPlant", JSON.stringify(newPlants));
    return;
  }

  // ✅ Existing logic
  setSelectedPlantDropdown(value);
  sessionStorage.setItem("selectedPlant", JSON.stringify(value));
};

  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAlertsOpen, setIsAlertsOpen] = useState(false);
  const [showNotificationDropdown, setShowNotificationDropdown] =
    useState(false);
  const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] =
    useState(false);

  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedController, setSelectedController] = useState("");
  const [availableRoles, setAvailableRoles] = useState<string[]>([]);
  const [selectedRole, setSelectedRole] = useState<string>("planner"); // Default role is 'Planner'
  const dispatch = useDispatch();
  const SELECT_ALL = "ALL";
  const currentRole = useSelector(
    (state: RootState) => state.userRoles?.currentRole,
  );
  const roles = useSelector((state: RootState) => state.userRoles?.roles);

  const effectiveRoleForUi =
    selectedRoleDropdown || (typeof currentRole === "string" ? currentRole : null);
  const effectiveRoleId = resolveRoleId(effectiveRoleForUi);
  const isApproverViewRoute = location.pathname.startsWith("/approverView");
  const isDataErrorRoute = location.pathname === "/admin/data-error";
  const isSupportTicketSummaryRoute =
    location.pathname === "/admin/support-ticket-summary";
  const isRoleOnlyRouteForSupportAndSsaAdmin =
    isApproverViewRoute || isDataErrorRoute || isSupportTicketSummaryRoute;
  const hideRegionAndPlantForSupportInApproverView =
    isRoleOnlyRouteForSupportAndSsaAdmin &&
    (effectiveRoleId === "it_support" ||
      effectiveRoleId === "ssa_admin" ||
      effectiveRoleId === "business_support");

  const hideRegionAndPlantGlobally =
    location.pathname === "/admin/adminView" ||
    location.pathname === "/admin/ssa-control";

  const isDashboard = location.pathname === "/ct-dashboard";
  const isDev = process.env.REACT_APP_ENVT === "DEV";



  // Auto-trigger "Go" on page navigation so destination pages always fetch fresh data
  useEffect(() => {
    if (selectedPlantDropdown.length > 0) {
      dispatch(setSelectedPlant(selectedPlantDropdown));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const storedRoles = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
    console.log(storedRoles);
    console.log(roles);
    if (roles.length > 0) {
      setAvailableRoles(roles);
    } else if (storedRoles.length > 0) {
      setAvailableRoles(storedRoles);
    } else {
      setAvailableRoles(["planner"]);
    }
  }, [roles]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const plant = params.get("plant");
    // const region = params.get("region");
    // const controller = params.get("controller");

    if (plant) {
      setSelectedLocation(plant);

      dispatch(setLocationDetails(plant));
    }
    // if (region) setSelectedRegion(region);
    // if (controller) setSelectedController(controller);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Update only query params, keep current pathname
    navigate(`${location.pathname}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation, selectedRegion, selectedController]);

  // useEffect(() => {
  //   // If first load and not on a known route, take user to Planner input
  //   if (selectedRole === 'Planner') {
  //     const isPlannerRoute =
  //       location.pathname.startsWith('/endUserView/input') ||
  //       location.pathname.startsWith('/endUserView');
  //     if (!isPlannerRoute) {
  //       navigate(`/endUserView/input${buildQuery()}`, { replace: true });
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);

  //   const plant = params.get("plant");
  //   const region = params.get("region");

  //   if (!plant && !region) {
  //     const defaultPlant = "5040";
  //     const defaultRegion = "North";

  //     setSelectedLocation(defaultPlant);
  //     dispatch(setLocationDetails(defaultPlant));
  //     setSelectedRegion(defaultRegion);

  //     navigate(
  //       `${location.pathname}?plant=${defaultPlant}&region=${defaultRegion}`,
  //       { replace: true },
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (currentRole) {
      // ensure the dropdown reflects the store's current role
      setSelectedRole(String(currentRole));
    }
  }, [currentRole]);

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
  const toggleAlertsDrawer = () => setIsAlertsOpen((prev) => !prev);

  const handleBellClick = () => {
    if (isDashboard) {
      toggleAlertsDrawer();
    } else {
      setShowNotificationDropdown((prev) => !prev);
    }
  };

  const handleAlertsFromDropdown = () => {
    setShowNotificationDropdown(false);
    setIsAlertsOpen(true);
  };

  const handleNotificationsFromDropdown = () => {
    setShowNotificationDropdown(false);
    setIsNotificationDrawerOpen(true);
  };

  // Close dropdown on outside click
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node | null;
      if (
        dropdownRef.current &&
        target &&
        !dropdownRef.current.contains(target)
      ) {
        setShowNotificationDropdown(false);
      }
    }

    if (showNotificationDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotificationDropdown]);

  // Ensure userName and userEmail are always string (never unknown)
  const safeUserName =
    typeof userName === "string" ? userName : String(userName ?? "");
  const safeUserEmail =
    typeof userEmail === "string" ? userEmail : String(userEmail ?? "");
  console.log("plant api", apiCall);
  return (
    <div className="main-header" ref={props?.headerRef}>
      <Toolbar className="toolbar_header">
        <div className="main-box">
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>

          {props.showIcons !== false && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {/* <div onClick={toggleDrawer} style={{ cursor: "pointer" }}>
                <MessageIcon />
              </div>
              {isDev && <MessageDrawer open={isDrawerOpen} onClose={toggleDrawer} />}


              <div
                style={{ cursor: "pointer", position: "relative" }}
                ref={dropdownRef}
              >
                <span onClick={handleBellClick}>
                  <BellIcon />
                </span>

                {isDev && !isDashboard && showNotificationDropdown && (
                  <NotificationDropdown
                    onAlertsClick={handleAlertsFromDropdown}
                    onNotificationsClick={handleNotificationsFromDropdown}
                  />
                )}
              </div>


              {isDev && <Alerts open={isAlertsOpen} onClose={toggleAlertsDrawer} />}


              {isDev && <NotificationComponent
                open={isNotificationDrawerOpen}
                onClose={() => setIsNotificationDrawerOpen(false)}
              />} */}

              {/* New Dropdowns */}

              {/* Dependent Dropdowns */}
              <div className="dropdowns">
                {/* Role Dropdown */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: 140,
                  }}
                >
                  <label
                    htmlFor="role-dropdown"
                    style={{ marginBottom: 4, fontSize: 13 }}
                  >
                    Role
                  </label>
                  <select
                    id="role-dropdown"
                    value={selectedRoleDropdown}
                    onChange={(e) => handleRoleDropdownChange(e.target.value)}
                    style={{ minWidth: 140, padding: "6px 10px" }}
                  >
                    <option value="" disabled>
                      {loading ? 'Please wait...' : 'Select Role'}
                    </option>
                    {roleOptions.map((role) => (
                      <option key={role} value={role}>
                        {getRoleDisplayName(role)}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Hide region and plant dropdowns on /admin/adminView and /admin/data-error */}
                {!hideRegionAndPlantGlobally &&
                  !hideRegionAndPlantForSupportInApproverView && (
                  <>
                    {/* Region Dropdown (MULTI‑SELECT like Plant) */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minWidth: 180,
                      }}
                    >
                      <label
                        htmlFor="region-dropdown"
                        style={{ marginBottom: 4, fontSize: 13 }}
                      >
                        Region
                      </label>

                      <Select
                        multiple
                        displayEmpty
                        value={selectedRegionDropdown}
                        onChange={handleRegionDropdownChange}
                        renderValue={(selected) => {
                          if (loading) return <span style={{ color: "#bdbdbd" }}>Loading...</span>;
                          const values = selected as string[];
                          if (values.length === 0) {
                            return <span style={{ color: "#bdbdbd" }}>Select region</span>;
                          }
                          if (values.length > 2) {
                            return `${values.slice(0, 2).join(", ")}, +${values.length - 2} more`;
                          }
                          return values.join(", ");
                        }}
                        sx={{
                          minWidth: "140px",
                          padding: "6px 10px",
                          backgroundColor: "#000",
                          border: "1px solid #444",
                          maxHeight: "30px",
                          color: "#fff",
                          "& .MuiSelect-icon": { color: "#fff" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#444",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#888",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#888",
                          },
                          "&.Mui-disabled": {
                            color: "#9e9e9e",
                            WebkitTextFillColor: "#9e9e9e",
                            opacity: 1,
                          },
                        }}
                      >
                        <MenuItem value={SELECT_ALL}>
                          <Checkbox
                            checked={
                              selectedRegionDropdown.length ===
                                regionOptions.length && regionOptions.length > 0
                            }
                            indeterminate={
                              selectedRegionDropdown.length > 0 &&
                              selectedRegionDropdown.length <
                                regionOptions.length
                            }
                          />
                          <ListItemText
                            primary={
                              selectedRegionDropdown.length ===
                                regionOptions.length && regionOptions.length > 0
                                ? "Deselect All"
                                : "Select All"
                            }
                          />
                        </MenuItem>
                        {regionOptions.map((region) => (
                          <MenuItem key={region} value={region}>
                            <Checkbox
                              checked={selectedRegionDropdown.includes(region)}
                              size="small"
                            />
                            <ListItemText primary={region} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minWidth: 180,
                      }}
                    >
                      <label
                        htmlFor="plant-dropdown"
                        style={{ marginBottom: 4, fontSize: 13 }}
                      >
                        Plant
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <Select
                          multiple
                          displayEmpty
                          disabled={!selectedRegionDropdown.length}
                          value={selectedPlantDropdown}
                          onChange={handlePlantDropdownChange}
                          renderValue={(selected) => {
                            if (loading)
                              return (
                                <span style={{ color: "#bdbdbd" }}>
                                  Loading...
                                </span>
                              );
                            const values = selected as string[];
                            if (values.length === 0) {
                              return (
                                <span style={{ color: "#bdbdbd" }}>
                                  Select plant
                                </span>
                              );
                            }
                            if (values.length > 2) {
                              return `${values
                                .slice(0, 2)
                                .join(", ")}, +${values.length - 2} more`;
                            }
                            return values.join(", ");
                          }}
                          sx={{
                            minWidth: "140px",
                            padding: "6px 10px",
                            backgroundColor: "#000",
                            border: "1px solid #444",
                            maxHeight: "30px",
                            color: "#fff",
                            "& .MuiSelect-icon": { color: "#fff" },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#444",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#888",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#888",
                            },
                            "&.Mui-disabled": {
                              color: "#9e9e9e",
                              WebkitTextFillColor: "#9e9e9e",
                              opacity: 1,
                            },
                          }}
                        >
                          <MenuItem value={SELECT_ALL}>
                            <Checkbox
                              checked={
                                selectedPlantDropdown.length ===
                                  plantOptions.length &&
                                plantOptions.length > 0
                              }
                              indeterminate={
                                selectedPlantDropdown.length > 0 &&
                                selectedPlantDropdown.length <
                                  plantOptions.length
                              }
                            />
                            <ListItemText
                              primary={
                                selectedPlantDropdown.length ===
                                  plantOptions.length &&
                                plantOptions.length > 0
                                  ? "Deselect All"
                                  : "Select All"
                              }
                            />
                          </MenuItem>
                          {plantOptions.map((plant) => (
                            <MenuItem key={plant} value={plant}>
                              <Checkbox
                                checked={selectedPlantDropdown.includes(
                                  plant,
                                )}
                                size="small"
                              />
                              <ListItemText primary={plant} />
                            </MenuItem>
                          ))}
                        </Select>
                        <button
                          disabled={
                            selectedPlantDropdown.length === 0 || apiCall
                          }
                          onClick={() => {
                            dispatch(setSelectedPlant(selectedPlantDropdown));
                          }}
                          style={{
                            height: 30,
                            minWidth: 48,
                            padding: "0 14px",
                            background: "transparent",
                            color: "#fff",
                            border: "1px solid #444",
                            borderRadius: 4,
                            fontSize: 13,
                            fontWeight: 500,
                            cursor:
                              selectedPlantDropdown.length === 0 || apiCall
                                ? "not-allowed"
                                : "pointer",
                            opacity:
                              selectedPlantDropdown.length === 0 || apiCall
                                ? 0.6
                                : 1,
                          }}
                        >
                          Go
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Show user name and email after profile icon */}
              <div
                style={{
                  display: "flex",
                  marginTop: "12px",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <ProfileDropdown />
                {safeUserName && safeUserEmail && (
                  <div
                    style={{
                      color: "#fff",
                      fontSize: 13,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <span>{safeUserName}</span>
                    <span style={{ fontSize: 11, opacity: 0.8 }}>
                      {safeUserEmail}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Toolbar>

      <div className="gradient_section">
        <span className="env-text">
          {process.env.REACT_APP_ENVT === "DEV"
            ? "DEV Environment"
            : process.env.REACT_APP_ENVT === "SIT"
              ? "SIT Environment"
              : process.env.REACT_APP_ENVT === "UAT"
                ? "UAT Environment"
                : ""}
        </span>
      </div>
    </div>
  );
};

export default Header;
